import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/ProductPage";
import GuidePage from "../pages/GuidePage";
import FaqPage from "../pages/FaqPage";
import SolutionPage from "../pages/SolutionPage";
import GuideArticlePage from "../pages/GuideArticlePage";
import SecurityPage from "../pages/SecurityPage";
import PricingPage from "../pages/PricingPage";
import ComparisonPage from "../pages/ComparisonPage";
import ProductScopePage from "../pages/ProductScopePage";
import DemoPage from "../pages/DemoPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  { path: "/ozellikler", element: <ProductPage /> },
  { path: "/kullanim-rehberi", element: <GuidePage /> },
  { path: "/sss", element: <FaqPage /> },
  // Eski bilgi merkezi ve nasıl çalışır bağlantılarını, tekrar eden sayfalar
  // yerine tek ve kapsamlı kullanım rehberinde topluyoruz.
  { path: "/bilgi-merkezi", element: <Navigate to="/kullanim-rehberi" replace /> },
  { path: "/nasil-calisir", element: <Navigate to="/kullanim-rehberi" replace /> },
  { path: "/guven-ve-veri-duzeni", element: <SecurityPage /> },
  { path: "/fiyatlandirma", element: <PricingPage /> },
  { path: "/karsilastir", element: <ComparisonPage /> },
  { path: "/urun-kapsami", element: <ProductScopePage /> },
  { path: "/demo", element: <DemoPage /> },
  { path: "/rehber/:slug", element: <GuideArticlePage /> },
  { path: "/:slug", element: <SolutionPage /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
